import { axiosClient } from 'www/utils'
import type { ApiScheduleServicesParamsPost, ApiScheduleServicesResponsePost } from 'www/api/apiScheduleServices.types'

export default {
  post(params: ApiScheduleServicesParamsPost) {
    return axiosClient.post<ApiScheduleServicesResponsePost>('/ajax/diagnostika/services/schedule/', params)
  },
}
